import React from 'react'

const MobileMenu = () => {
  return (
    <div className='block md:hidden '>
        <div className='space-y-1 cursor-pointer '>
            <div className='bg-gega-grey w-8 h-1 rounded-full'> </div>
            <div className='bg-gega-grey w-8 h-1 rounded-full'> </div>
            <div className='bg-gega-grey w-8 h-1 rounded-full'> </div>

           

        </div>
      
    </div>
  )
}

export default MobileMenu
